import { Node } from '@tiptap/core';

export const WordDocument = Node.create({
    name: 'doc',
    topNode: true,
    content: 'section+',
    selectable: false,
});
